module.exports = __webpack_public_path__ + "img/help.cb95a1f6.svg";